// Supplied filenames identify concepts, but do not establish language or region.
// Samples stay separate from moderated community videos and their like counts.
export const samples = [
  [
    "hello",
    "Hello",
    "你好",
    "A greeting or expression of goodwill.",
    "用于打招呼或表示问候的常用语。",
    ["one-1", "one-2", "one-3", "one-4", "one-5"],
  ],
  [
    "vulgar",
    "Vulgar",
    "粗俗",
    "Language or behavior considered coarse or impolite.",
    "被认为粗俗或不礼貌的语言或行为。",
    ["vulgar-002", "vulgar-001"],
  ],
  [
    "afternoon",
    "Afternoon",
    "下午",
    "The time between noon and evening.",
    "中午到傍晚之间的时间。",
    ["afternoon-001"],
  ],
  [
    "work",
    "Work",
    "工作",
    "An activity involving effort to achieve a purpose.",
    "为实现目标而付出努力的活动。",
    ["work-001"],
  ],
  [
    "sorry",
    "Sorry",
    "对不起",
    "An expression of regret or an apology.",
    "表达歉意或道歉。",
    ["sorry-001"],
  ],
  [
    "unity",
    "Unity",
    "团结",
    "Being joined together by a shared purpose.",
    "因共同目标而团结在一起。",
    ["unity-001"],
  ],
  [
    "whatif",
    "What if",
    "如果……怎么办",
    "A question about a possible situation.",
    "询问某种可能情况的问题。",
    ["whatif-002"],
  ],
  [
    "womensday",
    "Women’s Day",
    "妇女节",
    "A day recognizing women and their contributions.",
    "纪念女性及其贡献的节日。",
    ["womensday-001"],
  ],
  [
    "alternative",
    "Alternative",
    "另一种选择",
    "Another available choice or possibility.",
    "另一种可用的选择或可能性。",
    ["alternative-001"],
  ],
  [
    "appeal",
    "Appeal",
    "呼吁",
    "An earnest request for help or action.",
    "恳切请求帮助或行动。",
    ["appeal-001"],
  ],
  [
    "board",
    "Board",
    "板",
    "A flat piece of rigid material.",
    "一块平坦的硬质材料。",
    ["board-001"],
  ],
  [
    "dignified",
    "Dignified",
    "庄重",
    "Showing calm self-respect and composure.",
    "表现出沉着、自尊和稳重。",
    ["dignified-001"],
  ],
  [
    "dogdays",
    "Dog days",
    "三伏天",
    "The hottest days of summer.",
    "夏季最炎热的日子。",
    ["dogdays-001"],
  ],
  [
    "hundred",
    "Hundred",
    "一百",
    "The number 100.",
    "数字100。",
    ["hundred-001"],
  ],
  [
    "hurrah",
    "Hurrah",
    "好哇",
    "An exclamation of joy or approval.",
    "表达喜悦或赞同的欢呼。",
    ["hurrah-001"],
  ],
  [
    "insufficient",
    "Insufficient",
    "不足",
    "Not enough for a particular need.",
    "不足以满足某种需要。",
    ["insufficient-001"],
  ],
  [
    "monthend",
    "Month end",
    "月底",
    "The end of a calendar month.",
    "一个日历月的末尾。",
    ["monthend-001", "monthend"],
  ],
  [
    "nextmonth",
    "Next month",
    "下个月",
    "The month after the current one.",
    "当前月份之后的一个月。",
    ["nextmonth-001"],
  ],
  [
    "nextweek",
    "Next week",
    "下周",
    "The week after the current one.",
    "当前星期之后的一周。",
    ["nextweek-001", "nextweek"],
  ],
  ["one", "One", "一", "The number 1.", "数字1。", ["one-001"]],
  [
    "petition",
    "Petition",
    "请愿",
    "A formal request for action or change.",
    "要求行动或改变的正式请求。",
    ["petition-001"],
  ],
  [
    "superior",
    "Superior",
    "优越",
    "Higher in quality, position, or rank.",
    "在质量、地位或等级上更高。",
    ["superior-001"],
  ],
  [
    "tenthousand",
    "Ten thousand",
    "一万",
    "The number 10,000.",
    "数字10,000。",
    ["tenthousand-001"],
  ],
  [
    "threekingdoms",
    "Three Kingdoms",
    "三国",
    "The historical kingdoms of Wei, Shu, and Wu.",
    "历史上的魏、蜀、吴三个政权。",
    ["threekingdoms-001"],
  ],
  [
    "threemonths",
    "Three months",
    "三个月",
    "A period lasting three months.",
    "持续三个月的时间。",
    ["threemonths-001"],
  ],
  ["two", "Two", "二", "The number 2.", "数字2。", ["two-001"]],
  [
    "unfilial",
    "Unfilial",
    "不孝",
    "Failing to show care or respect for one’s parents.",
    "未对父母表现出关爱或尊重。",
    ["unfilial-001"],
  ],
  [
    "upstream",
    "Upstream",
    "上游",
    "Toward the source of a river.",
    "朝向河流源头的方向。",
    ["upstream-001"],
  ],
] as const;
export const sampleUrl = (clip: string) => `/sample-videos/${clip}.mp4#t=0.001`;
export const samplePoster = (clip: string) =>
  `/sample-videos/posters/${clip}.jpg`;
